import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportResponseHistoryService {
  private apiUrl = environment.apiUrl + '/report_response_histories/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  get(reportResponseId?:string): Observable<any> {
    let httpParams = new HttpParams();
    if (reportResponseId) httpParams = httpParams.set('reportResponseId', reportResponseId);
    return this.http.get(`${this.apiUrl}get`, { params: httpParams });
  }

  getView(reportResponseId:string): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('reportResponseId', reportResponseId); // Cambia esto según tu lógica
    return this.http.get(`${this.apiUrl}getView`, { params: httpParams });
  }

  getById(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl + 'get/' + id)
  }
  update(id: string, userData: any): Observable<any> {
    console.log(userData)
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }

  updateStateInReview(id: string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'updateStateInReview/' + id,{});
  }
  updateStateInAccept(id: string,reviewerComment:string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'updateStateInAccept/' + id,{reviewerComment});
  }
  updateStateInReject(id: string,reviewerComment:string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'updateStateRejected/' + id,{reviewerComment});
  }
  updateStateCorrection(id: string, reviewerComment:string): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'updateStateCorrection/' + id,{reviewerComment});
  }

  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl + 'save/', userData);
  }
}

